export const CleanObject = (obj) => {
  if (
    obj === null ||
    obj === undefined ||
    (typeof obj === "string" && obj.trim() === "")
  ) {
    return undefined;
  }

  if (Array.isArray(obj)) {
    const cleanedArray = obj
      .map((item) => CleanObject(item))
      .filter((item) => item !== undefined);
    return cleanedArray.length ? cleanedArray : undefined;
  }

  if (typeof obj === "object" && !(obj instanceof File)) {
    const cleanedEntries = Object.entries(obj)
      .map(([key, value]) => [key, CleanObject(value)])
      .filter(([, value]) => value !== undefined);

    return cleanedEntries.length
      ? Object.fromEntries(cleanedEntries)
      : undefined;
  }

  return obj;
};

export const ToFormData = (obj, formData = new FormData(), parentKey = "") => {
  const object = CleanObject(obj);

  if (Array.isArray(object)) {
    object.forEach((item, index) => {
      const arrayKey = parentKey ? `${parentKey}[${index}]` : `${index}`;
      if (typeof item === "object" && !(item instanceof File)) {
        ToFormData(item, formData, arrayKey);
      } else {
        formData.append(arrayKey, item);
      }
    });
  } else if (
    object &&
    typeof object === "object" &&
    !(object instanceof File)
  ) {
    Object.keys(object).forEach((key) => {
      const value = object[key];
      const newKey = parentKey ? `${parentKey}[${key}]` : key;

      if (Array.isArray(value)) {
        if (value.every((item) => item instanceof File)) {
          value.forEach((item) => {
            formData.append(newKey, item);
          });
        } else {
          value.forEach((item, index) => {
            const arrayKey = `${newKey}[${index}]`;
            ToFormData(item, formData, arrayKey);
          });
        }
      } else if (value instanceof File) {
        formData.append(newKey, value);
      } else if (typeof value === "object") {
        ToFormData(value, formData, newKey);
      } else {
        formData.append(newKey, value);
      }
    });
  } else {
    if (parentKey) formData.append(parentKey, object);
  }

  return formData;
};

export const NestedFormData = (object, keyName = "imgFiles") => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => {
    if (!Array.isArray(object[key])) formData.append(key, object[key]);
    else if (key === keyName)
      object[key].forEach((val) => formData.append(key, val));
    else
      object[key].forEach((val, i) =>
        Object.keys(val).forEach((key1) =>
          formData.append(`${key}[${i}][${key1}]`, val[key1]),
        ),
      );
  });
  return formData;
};

export const BGNestedObjToFromData = (obj) => {
  const formData = new FormData();

  const traverse = (current, parentKey = "") => {
    Object.keys(current).forEach((key) => {
      const value = current[key];
      if (value === null || value === undefined || value === "") return;

      const newKey = parentKey ? `${parentKey}.${key}` : key;

      if (value instanceof File) {
        formData.append(newKey, value);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (item instanceof File) {
            formData.append(`${newKey}[${index}]`, item);
          } else if (item instanceof Object) {
            traverse(item, `${newKey}[${index}]`);
          } else {
            formData.append(`${newKey}[${index}]`, item);
          }
        });
      } else if (value instanceof Object) {
        traverse(value, newKey);
      } else {
        formData.append(newKey, value);
      }
    });
  };

  traverse(obj);
  return formData;
};
